const getTeamNameClassName = (team: string = 'unknown'): string =>
  'team_' + team.toLowerCase().replace(/ /g, '');

export default getTeamNameClassName;
